import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, IconButton, Drawer, List, ListItem,
  ListItemIcon, ListItemText, Box, Divider, Button,
} from '@mui/material';
import {
  Menu as MenuIcon, Home, Assessment, Person, Mail, Settings,
  Logout, Close,
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

const MobileHeader: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const { user, isAthlete, isCompany, logout } = useAuth();

  const handleNav = (path: string) => {
    setDrawerOpen(false);
    navigate(path);
  };

  const handleLogout = async () => {
    setDrawerOpen(false);
    await logout();
    navigate('/');
  };

  const athleteMenuItems = [
    { label: 'ダッシュボード', icon: <Home />, path: '/athlete/dashboard' },
    { label: 'キャリア診断', icon: <Assessment />, path: '/assessment' },
    { label: 'プロフィール', icon: <Person />, path: '/profile/view' },
    { label: 'メッセージ', icon: <Mail />, path: '/athlete/scouts' },
    { label: '公開設定', icon: <Settings />, path: '/profile/settings' },
  ];

  const companyMenuItems = [
    { label: 'ダッシュボード', icon: <Home />, path: '/company/dashboard' },
    { label: 'アスリート検索', icon: <Person />, path: '/company/search' },
    { label: 'スカウト管理', icon: <Mail />, path: '/company/scouts' },
  ];

  const menuItems = isAthlete ? athleteMenuItems : isCompany ? companyMenuItems : [];

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          display: { xs: 'block', md: 'none' },
          bgcolor: '#0066cc',
          paddingTop: 'env(safe-area-inset-top)',
        }}
      >
        <Toolbar sx={{ minHeight: 56 }}>
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, fontWeight: 700, fontSize: '1.1rem', cursor: 'pointer' }}
            onClick={() => navigate('/')}
          >
            Athlead
          </Typography>
          {user ? (
            <IconButton color="inherit" onClick={() => setDrawerOpen(true)} edge="end">
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button color="inherit" size="small" onClick={() => navigate('/auth/athlete-login')}>
                ログイン
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 280 } }}
      >
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {isAthlete && user ? (user as any).name || 'アスリート' : ''}
            {isCompany && user ? (user as any).companyName || '企業' : ''}
          </Typography>
          <IconButton onClick={() => setDrawerOpen(false)}>
            <Close />
          </IconButton>
        </Box>
        <Divider />
        <List>
          {menuItems.map((item) => (
            <ListItem
              key={item.path}
              onClick={() => handleNav(item.path)}
              sx={{ cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          <ListItem
            onClick={handleLogout}
            sx={{ cursor: 'pointer', color: 'error.main', '&:hover': { bgcolor: 'action.hover' } }}
          >
            <ListItemIcon sx={{ minWidth: 40, color: 'error.main' }}><Logout /></ListItemIcon>
            <ListItemText primary="ログアウト" />
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default MobileHeader;
